import useSWRImmutable from 'swr/immutable';
import { QueryKey } from '@/api/queryKey';
import { getUserWebappRoutesAccess, GetUserWebappRoutesAccessParams } from '@/api/user-resource-access';

export const useUserWebappRoutesAccess = (userId: string | undefined, params: GetUserWebappRoutesAccessParams) => {
  const swrResponse = useSWRImmutable(
    () => QueryKey.GetUserWebappRoutesAccess(userId, params),
    () => (userId ? getUserWebappRoutesAccess(params) : null)
  );

  return swrResponse;
};
